module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/16_9.20ec3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/16_9.jpg
// module id = IujW
// module chunks = 1